import { rtkApi, GET_CATEGORIES } from '@/shared/api/rtkApi';
import type {
  CreateAdminCategoryRequest,
  CreateAdminCategoryResponse,
  DeleteAdminCategoryResponse,
  GetAdminCategoriesResponse,
  ToggleAdminCategoryActiveResponse,
  UpdateAdminCategoryRequest,
  UpdateAdminCategoryResponse,
} from './types';

export const categoriesApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    getAdminCategories: build.query<GetAdminCategoriesResponse, void>({
      query: () => '/admin/categories',
      providesTags: [GET_CATEGORIES],
    }),
    getPublicCategories: build.query<GetAdminCategoriesResponse, void>({
      query: () => '/categories',
      providesTags: [GET_CATEGORIES],
    }),
    createAdminCategory: build.mutation<CreateAdminCategoryResponse, CreateAdminCategoryRequest>({
      query: (body) => ({
        url: '/admin/categories',
        method: 'POST',
        body,
      }),
      invalidatesTags: [GET_CATEGORIES],
    }),
    updateAdminCategory: build.mutation<
      UpdateAdminCategoryResponse,
      { id: number; body: UpdateAdminCategoryRequest }
    >({
      query: ({ id, body }) => ({
        url: `/admin/categories/${id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: [GET_CATEGORIES],
    }),
    deleteAdminCategory: build.mutation<DeleteAdminCategoryResponse, number>({
      query: (id) => ({
        url: `/admin/categories/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [GET_CATEGORIES],
    }),
    toggleAdminCategoryActive: build.mutation<ToggleAdminCategoryActiveResponse, number>({
      query: (id) => ({
        url: `/admin/categories/${id}/toggle-active`,
        method: 'POST',
      }),
      invalidatesTags: [GET_CATEGORIES],
    }),
  }),
});

export const {
  useGetAdminCategoriesQuery,
  useGetPublicCategoriesQuery,
  useCreateAdminCategoryMutation,
  useUpdateAdminCategoryMutation,
  useDeleteAdminCategoryMutation,
  useToggleAdminCategoryActiveMutation,
} = categoriesApi;
